
import { CALL_INTAKE_V2_API } from 'middleware/intakeV2Api';
import {
  GET_FEE_SUMMARIES_REQUEST,
  GET_FEE_SUMMARIES_SUCCESS,
    GET_FEE_SUMMARIES_FAILURE,
    GET_FEE_BY_ID_REQUEST,
    GET_FEE_BY_ID_SUCCESS,
    GET_FEE_BY_ID_FAILURE,
    POST_FEE_REQUEST,
    POST_FEE_SUCCESS,
    POST_FEE_FAILURE,
    UPDATE_FEE_REQUEST,
    UPDATE_FEE_SUCCESS,
    UPDATE_FEE_FAILURE,
    DELETE_FEE_REQUEST,
    DELETE_FEE_SUCCESS,
    DELETE_FEE_FAILURE,
    SET_FEE_ID,
    UPDATE_FEE_STATUSES_REQUEST,
    UPDATE_FEE_STATUSES_SUCCESS,
    UPDATE_FEE_STATUSES_FAILURE,
    INSERT_FEE_COMMENT_REQUEST,
    INSERT_FEE_COMMENT_SUCCESS,
    INSERT_FEE_COMMENT_FAILURE
} from './fees.types';

export const getFeeSummaries = () => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_FEE_SUMMARIES_REQUEST, GET_FEE_SUMMARIES_SUCCESS, GET_FEE_SUMMARIES_FAILURE],
      authenticated: true,
      endpoint: 'api/fees/summaries',
      method: 'GET',
    },
  };
};

export const getFeeById = (feeId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [GET_FEE_BY_ID_REQUEST, GET_FEE_BY_ID_SUCCESS, GET_FEE_BY_ID_FAILURE],
      authenticated: true,
      endpoint: `api/fees/${feeId}`,
      method: 'GET',
    },
  };
};

export const postFee = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [POST_FEE_REQUEST, POST_FEE_SUCCESS, POST_FEE_FAILURE],
      authenticated: true,
      endpoint: `api/fees`,
      method: 'POST',
      payload: values
    }
  };
};

export const updateFee = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_FEE_REQUEST, UPDATE_FEE_SUCCESS, UPDATE_FEE_FAILURE],
      authenticated: true,
      endpoint: `api/fees`,
      method: 'PUT',
      payload: values
    }
  };
};

export const updateFeeStatuses = values => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [UPDATE_FEE_STATUSES_REQUEST, UPDATE_FEE_STATUSES_SUCCESS, UPDATE_FEE_STATUSES_FAILURE],
      authenticated: true,
      endpoint: `api/fees/statusUpdate`,
      method: 'PUT',
      payload: values
    }
  };
};


export const deleteFee = feeId => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [DELETE_FEE_REQUEST, DELETE_FEE_SUCCESS, DELETE_FEE_FAILURE],
      authenticated: true,
      endpoint: `api/fees/${feeId}`,
      method: 'DELETE'
    }
  };
};

export const insertFeeComment = (feeRecordId, commentId) => {
  return {
    [CALL_INTAKE_V2_API]: {
      types: [INSERT_FEE_COMMENT_REQUEST, INSERT_FEE_COMMENT_SUCCESS, INSERT_FEE_COMMENT_FAILURE],
      authenticated: true,
      endpoint: `api/fees/${feeRecordId}/comments/${commentId}`,
      method: 'POST',
    }
  };
};

export const setFeeId = id => ({
  type: SET_FEE_ID,
  response: id
});